/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_GenerateInputs */

const en_settings_keys_generate = /** @type {(inputs: Settings_Keys_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const id_settings_keys_generate = /** @type {(inputs: Settings_Keys_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Settings_Keys_GenerateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_generate = /** @type {((inputs?: Settings_Keys_GenerateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_GenerateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_generate(inputs)
	return en_settings_keys_generate(inputs)
});